import { ContentSkeleton } from '@/components/loading/Skeleton'
/** Honest empty media states shared by the player and map layout. */
import { VideoOff, MapPinOff, TriangleAlert, Radio } from 'lucide-react'
import { registerPrimitive, type PrimitiveProps } from '../../layout'

export type EmptyStateVariant =
  | 'pre-event'
  | 'awaiting-cameras'
  | 'awaiting-route'
  | 'parsing-route'
  | 'route-failed'
  | 'ended'

interface EmptyStateConfig { state?: EmptyStateVariant }

const STATES = {
  'pre-event': { icon: VideoOff, text: 'Waiting for live cameras' },
  'awaiting-cameras': { icon: VideoOff, text: 'Waiting for a camera to connect' },
  'awaiting-route': { icon: MapPinOff, text: 'The course map isn’t available yet' },
  'parsing-route': { icon: MapPinOff, text: 'Loading the course map…' },
  'route-failed': { icon: TriangleAlert, text: 'The course map couldn’t be loaded' },
  ended: { icon: Radio, text: 'This live coverage has ended' },
} as const

export function EmptyStateInner({ state = 'awaiting-cameras' }: { state?: EmptyStateVariant }) {
  if (state === 'parsing-route') {
    return <div className="lv-empty"><ContentSkeleton label="Loading the course map" variant="media" className="max-w-xl p-6" /></div>
  }
  const { icon: Icon, text } = STATES[state]
  return (
    <div className="lv-empty" role="status">
      <div className="lv-empty-icon" aria-hidden="true"><Icon strokeWidth={1.75} /></div>
      <p className="lv-empty-copy">{text}</p>
    </div>
  )
}

export function EmptyState({ config }: PrimitiveProps) {
  const cfg = config as EmptyStateConfig
  return <EmptyStateInner state={cfg.state ?? 'pre-event'} />
}

registerPrimitive('EmptyState', EmptyState)
